import {Routes} from '@angular/router';

export const ActivitiesRoutes: Routes = [
    {
        path: 'qcm/:activityId',
        loadComponent: () => import('./qcm/qcm.component').then(m => m.QcmComponent),
    },
    {
        path: 'qcu/:activityId',
        loadComponent: () => import('./qcu/qcu.component').then(m => m.QcuComponent),
    },
    {
        path: 'pointimg/:activityId',
        loadComponent: () => import('./image-zoning/image-zoning.component').then(m => m.ImageZoningComponent)
    },
    {
        path: 'imgsoundzone/:activityId',
        loadComponent: () => import('./image-zoning-play-sound/image-zoning-play-sound.component').then(m => m.ImageZoningPlaySoundComponent),
    },
    {
        path: 'truefalse/:activityId',
        loadComponent: () => import('./true-false/true-false.component').then(m => m.TrueFalseComponent),
    },
    {
        path: 'ordon/:activityId',
        loadComponent: () => import('./ordon/ordon.component').then(m => m.OrdOnComponent),
    },
    {
        path: 'orderingmatching/:activityId',
        loadComponent: () => import('./order-matching/order-matching.component').then(m => m.OrderMatchingComponent),
    },
    {
        path: 'text-matching/:activityId',
        loadComponent: () => import('./text-matching/text-matching.component').then(m => m.TextMatchingComponent),
    },
    {
        path: 'awareness/:activityId',
        loadComponent: () => import('./awareness/awareness.component').then(m => m.AwarenessComponent),
    },
    {
        path: 'orderingmatching/:activityId',
        loadComponent: () => import('./order-matching/order-matching.component').then(m => m.OrderMatchingComponent)
    },
    {
        path: 'text-matching/:activityId',
        loadComponent: () => import('./text-matching/text-matching.component').then(m => m.TextMatchingComponent)
    },
    {
        path: 'fillinblanks/:activityId',
        loadComponent: () => import('./fill-in-blanks/fill-in-blanks.component').then(m => m.FillInBlanksComponent),
    },
    {
        path: 'shortanswer/:activityId',
        loadComponent: () => import('./short-answer/short-answer.component').then(m => m.ShortAnswerComponent),
    },
    {
        path: 'draw-line/:activityId',
        loadComponent: () => import('./draw-line/draw-line.component').then(m => m.DrawLineComponent),
    },
    {
        path: 'draw-line/:activityId',
        loadComponent: () => import('./draw-line/draw-line.component').then(m => m.DrawLineComponent)
    },
    {
        path: 'appaire/:activityId',
        loadComponent: () => import('./appaire/appaire.component').then(m => m.AppaireComponent),
    },
    {
        path: 'media/:activityId',
        loadComponent: () => import('./media/media.component').then(m => m.MediaComponent),
    },
    {
        path: 'divider/:activityId',
        loadComponent: () => import('./divider/divider.component').then(m => m.DividerComponent),
    },
    {
        path: 'audio/:activityId',
        loadComponent: () => import('./audio/audio.component').then(m => m.AudioComponent),
    },
    {
        path: 'video/:activityId',
        loadComponent: () => import('./video/video.component').then(m => m.VideoComponent),
    },
    {
        path: 'image/:activityId',
        loadComponent: () => import('./image/image.component').then(m => m.ImageComponent),
    },
    {
        path: 'interactiveimage/:activityId',
        loadComponent: () => import('./interactive-image/interactive-image.component').then(m => m.InteractiveImageComponent),
    },
    {
        path: 'summary/:activityId',
        loadComponent: () => import('./summary-activity/summary-activity.component').then(m => m.SummaryActivityComponent),
    },
    {
        path: 'medias/:activityId',
        loadComponent: () => import('./multimedia/multimedia.component').then(m => m.MultimediaComponent),
    },
    {
        path: 'external/:activityId',
        loadComponent: () => import('./external/external.component').then(m => m.ExternalComponent),
    },
    {
        path: 'gcm/:activityId',
        loadComponent: () => import('./multiple-choice-grid/multiple-choice-grid.component').then(m => m.MultipleChoiceGridComponent),
    },
    {
        path: 'tool/:activityId',
        loadComponent: () => import('./tool/tool.component').then(m => m.ToolComponent),
    },
    {
        path: 'memory/:activityId',
        loadComponent: () => import('./memory/memory.component').then(m => m.MemoryComponent),
    },
    {
        path: 'missing/:activityId',
        loadComponent: () => import('./what-is-missing/what-is-missing.component').then(m => m.WhatIsMissingComponent),
    },
    {
        path: 'recording/:activityId',
        loadComponent: () => import('./voice-recorder-activity/voice-recorder-activity.component').then(m => m.VoiceRecorderActivityComponent),
    },
    {
        path: 'imgsoundzone/:activityId',
        loadComponent: () => import('./image-zoning-play-sound/image-zoning-play-sound.component').then(m => m.ImageZoningPlaySoundComponent),
    },
    {
        path: 'missingaudio/:activityId',
        loadComponent: () => import('./what-is-missing-audio/what-is-missing-audio.component').then(m => m.WhatIsMissingAudioComponent), // Changed component to loadComponent
    }
];